import React from "react";


export function Button(props) {
  return (
    <div className="w-full">
      <button
        id={props.id}
        type={props.type}
        onClick={!props.disabled ? props.onClick: null  }
        {...props}
        className={
          props.roundedButton
            ? `w-full inline-flex justify-center items-center px-2 py-2 text-white bg-gradient-to-b from-[#1190E4] to-[#3552D8] rounded-full text-sm ${props?.extraClass}`
            : props.disabled
              ? `w-full inline-flex justify-center items-center px-2 py-2 text-white bg-gray-300 rounded-md text-sm ${props?.extraClass}`
              : props.isLight
                ? `w-full inline-flex justify-center items-center px-2 py-2 text-white bg-[#118740] rounded-md text-sm ${props?.extraClass}`
                : props.isBordered
                  ? `w-full inline-flex justify-center items-center font-bold px-2 py-2 text-[#138CE3] border border-[#138CE3] bg-white rounded-md text-sm ${props?.extraClass}`
                  : `w-full inline-flex justify-center items-center px-2 py-2 text-white bg-gradient-to-b from-[#1190E4] to-[#3552D8] rounded-md text-sm ${props?.extraClass}`
        }
        style={{ whiteSpace: "nowrap" }}
        disabled={props.disabled}
      >
        {props.icon && <span className="w-5 h-5 mr-1" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>{props.icon}</span>}
        {props.label}
      </button>
    </div>
  );
}
